import { render, staticRenderFns } from "./ModalImpressaoPedido.vue?vue&type=template&id=44c07810&scoped=true&"
import script from "./ModalImpressaoPedido.vue?vue&type=script&lang=js&"
export * from "./ModalImpressaoPedido.vue?vue&type=script&lang=js&"
import style0 from "./ModalImpressaoPedido.vue?vue&type=style&index=0&id=44c07810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c07810",
  null
  
)

export default component.exports